// extracted by css-extract-rspack-plugin
export default {"containerHidden":"container-hidden--r8GFkKemq8kaBtAL"};